/**
 * Extend Default Settings
 * Extends the default settings of an object.
 * Default properies will be overwritten if the same key matches.
 * This is a shallow extension only useful for simple (single level) objects.
 * @param {object} defaults
 * @param {object} settings
 */
export const extendDefaultSettings = (defaults, settings) => {
  for (const key in settings) {
    if (Object.prototype.hasOwnProperty.call(settings, key)) {
      defaults[key] = settings[key]
    }
  }

  return defaults
}

/**
 * Has Callback
 * Checks if object is a valid function.
 * @param {object} styleProperty
 * @return {boolean}
 */
export const hasCallback = (callback) => {
  return callback && typeof callback === 'function'
}

/**
 * Is Phone
 * Checks if string is a valid tel.
 * @param {string} tel
 * @return {boolean}
 */
export const isTel = (tel) => {
  return /^tel:/.test(tel)
}

/**
 * Is Email
 * Checks if string is a valid email.
 * @param {string} email
 * @return {boolean}
 */
export const isEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

/**
 * Capitalise First Letter
 * @param {string} text
 * @return {mixed}
 */
export const capitaliseFirstLetter = (text) => {
  if (text) {
    const words = text.split(' ')

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1)
    }

    return words.join(' ')
  }

  return null
}

/**
 * Track Event
 * @param {string} category
 * @param {string} action
 * @param {string} label
 * @return {void}
 */
export const trackEvent = (category, action, label) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label
    })
  }
}

/**
 * Track FB Event
 * @param {string} name
 * @return {void}
 */
export const trackFbEvent = (name) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', name)
  }
}

/**
 * Track Dot Digital Signups
 * @return {void}
 * @param signupVariable
 */
export const setupTrackEmbeddedFormEvent = (signupVariable = null) => {
  if (typeof window !== 'undefined' && window.ecPF != null) {
    const ecPFSignupVariable = signupVariable || 'yes_i_would_like_to_receive_newsletters_and_updates_from_the_media_sales_team_at_london_city_airport_find_out_about_your_rights_and_choices_and_how_we_use_your_information_in_london_city_airports_privacy_policy_'

    window.ecPF.onComplete(function (data) {
      const signedUp = data.form[ecPFSignupVariable]
      const formName = !Object.prototype.hasOwnProperty.call(data.form, 'name') && Object.prototype.hasOwnProperty.call(data.form, 'first_name') ? 'Newsletter' : 'Enquiry'

      window.dataLayer.push({ event: 'enquire_form_submit', form_name: formName })

      if (signedUp) {
        window.dataLayer.push({ event: 'subscribe_contact', contact_list: 'Newsletter sign up' })
      }
    })
  }
}

/**
 * Sets ContentGroup window variable used for the GTM tracking.
 * @param value
 */
export const setGTMContentGrouping = (value) => {
  if (typeof window !== 'undefined') {
    window.contentGroup = value
  }
}

/**
 * Set Content Grouping
 * @param {string} group
 * @param {string} value
 * @param {boolean} setForGTM
 * @return {void}
 */
export const setContentGrouping = (group, value, setForGTM = false) => {
  if (typeof window !== 'undefined') {
    if (setForGTM) {
      setGTMContentGrouping(value)
    }
    // datalayer.push({content_group: value})
  }
}

/**
 * @param {string} srcSet
 * @returns {string}
 */
export const appendFitFillToSrcSet = (srcSet) => {
  return srcSet.replace(/(\S+)\s*(\d+w)/g, '$1&fit=fill $2')
}
